module.exports = __webpack_public_path__ + "static/media/logo.18cad636.svg";